import {
  ACCESS_LEVELS,
} from '@/lib/consts.ts'
import { __t } from '@/lib/helpers'
import { ROUTE_META_PARAMS } from '@/router/consts.ts'

export default {
  path: 'details',
  name: 'settings-details',
  meta: {
    title: __t('routes.settings.details.title'),
    subtitle: __t('routes.settings.details.subtitle'),
    icon: 'business-details',
    backgroundIcon: 'business-details',
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
  },
  component: () => import('@/views/business/settings/details/index.vue'),
  children: [
    {
      path: 'info',
      name: 'details-info',
      meta: {
        title: __t('routes.settings.details.info.title'),
        subtitle: __t('routes.settings.details.info.subtitle'),
        hintKey: 'hintFeatureBizDetails',
      },
      component: () => import('@/views/business/settings/details/info.vue'),
    },
    {
      path: 'category',
      name: 'details-category',
      meta: {
        title: __t('routes.settings.details.category.title'),
        subtitle: __t('routes.settings.details.category.subtitle'),
        hintKey: 'hintFeatureBizCategory',
      },
      component: () => import('@/views/business/settings/details/category.vue'),
    },
    {
      path: 'photos',
      name: 'details-photos',
      meta: {
        title: __t('routes.settings.details.photos.title'),
        subtitle: __t('routes.settings.details.photos.subtitle'),
        hintKey: 'hintFeatureBizPhotos',
      },
      component: () => import('@/views/business/settings/details/photos.vue'),
    },
    {
      path: 'cover-image',
      name: 'details-cover-image',
      meta: {
        title: __t('routes.settings.details.cover-image.title'),
        [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: () => false,
      },
      component: () => import('@/views/business/settings/details/cover-image.vue'),
    },
    {
      path: 'opening-hours',
      name: 'details-opening-hours',
      meta: {
        title: __t('routes.settings.details.opening-hours.title'),
        subtitle: __t('routes.settings.details.opening-hours.subtitle'),
        hintKey: 'hintFeatureBizHours',
      },
      component: () => import('@/views/business/settings/details/opening-hours.vue'),
    },
    {
      path: 'venue-and-location',
      name: 'details-venue-and-location',
      meta: {
        title: __t('routes.settings.details.venue-and-location.title'),
        subtitle: __t('routes.settings.details.venue-and-location.subtitle'),
        hintKey: 'hintFeatureBizLocationServices',
      },
      component: () => import('@/views/business/settings/details/venue-and-location.vue'),
    },
    {
      path: 'custom-forms',
      name: 'custom-forms',
      meta: {
        title: __t('routes.settings.details.custom-forms.title'),
        subtitle: __t('routes.settings.details.custom-forms.subtitle'),
        defaultSubroute: {
          name: 'custom-forms.list',
        },
        hintKey: 'hintFeatureCustomForms',
      },
      component: () => import('@/views/business/settings/details/custom-forms/index.vue'),
      children: [
        {
          path: 'create',
          name: 'custom-forms.create',
          meta: {
            title: __t('routes.settings.details.custom-forms.title'),
            subtitle: __t('routes.settings.details.custom-forms.subtitle'),
            [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
          },
          component: () => import('@/views/business/settings/details/custom-forms/form.vue'),
        },
        {
          path: ':customFormId/form',
          name: 'custom-forms.edit',
          meta: {
            title: __t('routes.settings.details.custom-forms.title'),
            subtitle: __t('routes.settings.details.custom-forms.subtitle'),
            [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
          },
          component: () => import('@/views/business/settings/details/custom-forms/form.vue'),
        },
        {
          path: '',
          name: 'custom-forms.list',
          meta: {
            title: __t('routes.settings.details.custom-forms.title'),
            subtitle: __t('routes.settings.details.custom-forms.subtitle'),
            [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
          },
          component: () => import('@/views/business/settings/details/custom-forms/list.vue'),
        },
      ],
    },
    {
      path: 'health-safety-rules',
      name: 'settings.health-safety-rules',
      meta: {
        title: __t('routes.settings.health-safety-rules.title'),
        subtitle: __t('routes.settings.health-safety-rules.subtitle'),
        hintKey: 'hintFeatureHealthSafety',
      },
      component: () => import('@/views/business/settings/details/health-safety-rules.vue'),
    },
    {
      path: 'amenities',
      name: 'settings.amenities',
      meta: {
        title: __t('routes.settings.details.amenities.title'),
        subtitle: __t('routes.settings.details.amenities.subtitle'),
      },
      component: () => import('@/views/business/settings/details/amenities.vue'),
    },
  ],
}
